<!--  -->
<template>
  <div>
    <section class="page-banner" style="background-image: url(/static/img/tuotibg.png);">
      <div class="container">
          <div class="banner-tip">
              <h2 class="banner-title">直播中心</h2>
              <div class="bread-crumbs">
                Broadcast center
              </div>
          </div>
      </div>
    </section>  
     <section>
      <div class="container section-heading">
        <ul class="tab">
          <li class="tab-item" :class="state==''&&'active'" @click="handleTab('')">全部</li>
          <li class="tab-item" :class="state == '2' && 'active'" @click="handleTab(2)">已开始</li> 
          <li class="tab-item" :class="state == '3' && 'active'" @click="handleTab(3)">即将开播</li> 
          <li class="tab-item" :class="state == '4' && 'active'" @click="handleTab(4)">已结束</li>   
        </ul>          
        <div class="search-box">
            <input type="search" v-model="searchWords" placeholder="输入关键字...">
            <button type="submit" @click="toPage(1)"><img src="/static/img/search-line.png" width="21" height="21"/></button>
        </div>
      </div>
     </section>
    <section class="course-area course-area4">
    <div class="course-content-wrapper">
        <div class="container">
            <div>
                <div>
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                            <div class="row course-block">
                              <div :class="index == 0 ? 'col-lg-12' : 'col-lg-4'"  v-for="(live, index) in lives" :key="index">
                                 <div class="category-item" v-if="index == 0">
                                      <div class="course-tooltip">
                                        <span class="cat__title"><router-link :to="`/mylive/${live._id}`">{{ live.title }}</router-link></span>
                                      </div>
                                      <div class="category-content">
                                        <div class="teacher">
                                          <span :style="`padding-left:63px;background-image:url(/static/img/a1.png);background-repeat: no-repeat;background-size: 50px auto;background-position: left center;`" class="name">{{ live.teacher }}</span>
                                          <span class="tip">大学教授</span>
                                          <span class="tooltip-label">{{ dateFormat(new Date(live.time), "yyyy-MM-dd hh:mm") }}</span>
                                        </div>
                                        <div class="info">
                                          零基础学Python数据分析【华为开发者学堂证书】小白30分钟入门计算机等级测评-6月22日小白30分钟入门计算机等级测评-6月22日
                                        </div>
                                        <div class="cat__meta_right">
                                          <span class="datetime">直播时间 {{ dateFormat(new Date(live.time), "MM月dd日 hh:mm") }}</span>
                                          <!-- <span class="more" @click="$router.push(`/liveview`)">MORE</span> -->
                                        </div>
                                      </div>
                                      <div class="on-vodio" @click="$router.push(`/mylive/${live._id}`)">
                                        <img :src="live.picsrc ? `${global.remoteIp}/uploads/${live.picsrc}` : '/static/images/mor.jpg'" alt="">
                                      </div> 
                                  </div>    
                                <div v-else>
                                 <div class="post-item-1" :class="(index + 1) % 3 === 0 && 'post-item-clear'"  @click="$router.push(`/mylive/${live._id}`)">
                                    <div class="img">
                                      <img :src="`${global.remoteIp}/uploads/${live.picsrc}`" width="344" height="262" alt="">
                                    </div>
                                    <div class="b-post-details">
                                      <h3><a>{{ live.title }}</a></h3>
                                      <div class="bp-meta">
                                          <a class="a-color">{{ dateFormat(new Date(live.time), "yyyy-MM-dd hh:mm") }}</a>
                                          <a class="a-color a-changebac">{{ live.teacher }}</a>
                                      </div>
                                        <a class="read-more">{{ live.state == '1' ? '正在直播' : '暂未开播' }}<i v-if="live.state == '1'" class="arrow_right"></i></a>
                                    </div>
                                </div>
                                </div>
                              </div>
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                            <el-pagination
                            background
                            :page-size="7"
                            :hide-on-single-page="intTotal<=7"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
    </section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      lives: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
      state:""
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") {
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    handleTab(index) {
      this.state = index;
      this.toPage(1);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.state) {
        searchConditions += "&state=$regex:" + this.state;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=state";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/livings?page=${
            this.intCurrent
          }&limit=6${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.lives = res.data.data;
       //     this.toTop();
          }
        });
    },
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
/deep/ .el-pager li.active {
  color: #51be78;
}
/deep/ .el-input__inner{
	height: 61px;
    line-height: 61px;
    width:368.8px;
    margin-top:15px;
    font-size: 16px;
}
/deep/ .el-input__suffix{
     margin-top:15px;
     height: 61px;
   
}
/deep/ .el-select .el-input .el-select__caret{
  color: #4282CAFF;
    font-size: 23px;
    font-weight: 600;
}
.el-icon-search{
        line-height: 61px;
    font-size: 21px;
    margin-right: 10px;
}
/deep/ .el-radio{
    margin-right: 41px;
    margin-left: 27px;
}
/deep/ .el-radio__label{
    font-size:16px;
    /* font-weight: 600; */
}
/deep/ .el-radio__inner{
        border: 2px solid #4485CCFF;
}

.course-wrapperer{
	width: 1198px;
	height: 216px;
	background: #ffffff66;
	box-shadow: 0px 6px 17px 1px rgba(68, 133, 204, 0.27);
	border-radius: 5px;
	margin: auto;
	padding: 15px;
}

.col-lg-4 .category-item{
/* width: 294px;
height: 212px; */
width: 288px;
padding: 0px;
border: 1px solid #EEEEEE;
border-radius: 5px;
height:328.9px;
}
.col-lg-4 .category-item img{
width: 100%;
height: 212px;
border-radius: 5px;
}
.tooltip-label{
  font-size: 12px;
    color: #FFFFFF;
}
.cat__title {
  width: 200  px;
height: 16px;
font-size: 16px;
font-weight: 600;
color: #313F57;
text-align: left;
}
.cat__teacher{
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #737D85;
}
.cat__teacher a{
  color: #737D85;
}

.cat__time{
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #737D85;
text-align: center;
}
.cat__time a{
  color: #737D85;
}
.cat__title a{
  color: #313F57;
}

.category-content{
  margin-top: 17px;
  padding-right: 4px;
  padding-left: 7px;
  font-size: 16px;
}
.cat__meta_right{
      float: right;
      line-height:23px;
      width: auto;
}
.cat__meta_right a{
  color: #313F57;
      width: 41px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F68A03;
   
}
.col-lg-3{
  padding-left: 10px;
  padding-right:10px;
}
.course-area {
    /* height: 796px; */
    margin-top: 31px;
    line-height: 20px;
}
.section-heading{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-box input{
  border: 0;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  width: 235px;
  height: 66px;
  background: #F5F7FF;
}
.search-box input::placeholder{
  color: #B7B7B7;
}
.search-box input[type="search"] {
  height: 66px;
}
.search-box button {
  background: #F5F7FF;
  border: 0;
  height: 66px;
  line-height: 66px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-box button{
  padding: 0 20px;
}
.tab .tab-item{
  float: left;
  margin-right: 14px;
  width: 126px;
  height: 46px;
  background: #F8F8F8;
  border-radius: 5px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #737D85;
line-height: 46px;
}
.tab li.active{
border: 1px solid #4462CF;
color: #4462CF;
}
/* two search */
.col-lg-12{
  width: 1200px;
  margin-bottom: 44px;
}
.col-lg-12 .category-item{
  position: relative;
  width: 1200px;
  height: 417px;
}
.col-lg-12 .category-item .on-vodio{
  position: absolute;
  top: 0;
  right: 0;
  width: 679px;
height: 417px;
}
.col-lg-12 .category-item .on-vodio img{
  width: 679px;
height: 417px;
border-radius: 0;
}
.col-lg-12 .category-item .on-vodio::before{
   cursor: pointer;
  z-index: 1;
  position: absolute;
  content: '';
   top: 0;
  right: 0;
  width: 679px;
height: 417px;
background: #4462CF;
opacity: 0.63;
background-image: url(/static/img/bofang.png);
background-repeat: no-repeat;
background-size: 44px 44px;
background-position: center center;
}
.col-lg-12 .category-item .course-tooltip{
  position: absolute;
   top: 0;
  left: 0;
  width: 236px;
height: 62px;
background-image: url(/static/img/biaotiqan.png);
background-repeat: no-repeat;
background-size: 236px auto;
background-position: center center;
text-align: center;
}
.col-lg-12 .category-item .course-tooltip a{
  display: inline-block;
  width: 148px;
  height: 48px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 48px;
  text-align: center;
  -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.col-lg-12 .category-item .category-content{
  z-index: 2;
  position: absolute;
  padding: 38px 41px 45px 36px;
  left: 0;
  bottom: 0;
  width: 576px;
height: 313px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px rgba(200,200,200,0.38);
}
.col-lg-12 .category-item .category-content .teacher{
  width: 100%;
  height: 50px;
}
.col-lg-12 .category-item .category-content .teacher span{
  float: left;
padding: 0 13px;
height: 50px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 50px;
}
.col-lg-12 .category-item .category-content .teacher .tooltip-label{
  float: right;
  padding: 0;
  width: 200px;
  height: 50px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 48px;
  text-align: right;
}
.col-lg-12 .category-item .category-content .teacher span.tip{
  margin-top: 14.5px;
  padding: 0;
  width: 69px;
height: 21px;
background: #00D57A;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
line-height: 21px;
color: #FFFFFF;
text-align: center;
}
.col-lg-12 .category-item .category-content .info{
  margin-top: 30px;
  width: 481px;
height: 70px;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #4A576A;
line-height: 40px;
overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.col-lg-12 .category-item .category-content .cat__meta_right{
  margin-top: 71px;
  width: 100%;
}
.col-lg-12 .category-item .category-content .cat__meta_right .datetime{
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 16px;
}
.col-lg-12 .category-item .category-content .cat__meta_right .more{
  cursor: pointer;
  float: right;
  padding-right: 41px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #F55C57;
line-height: 18px;
background-image: url(/static/img/youla.png);
background-repeat: no-repeat;
background-size: 35px auto;
background-position: right center;
}
.post-item-1 {
  position: relative;
  margin-right: 30px;
  margin-bottom: 42px;
  width: 380px;
  height: 437px;
  background: #FFFFFF;
  box-shadow: 0px 0px 24px 0px rgba(225, 211, 211, 0.35);
  border-radius: 20px;
  padding: 15px 18px;
}

.post-item-clear {
  margin-right: 0px;
}

.post-item-1 div.img {
  width: 344px;
  height: 262px;
  background: #FFF1F1;
  border-radius: 20px;
  overflow: hidden;
}

.b-post-details {
  position: relative;
  padding-top: 23px;
}

.bp-meta {
  position: relative;
  display: flex;
  justify-content: flex-start;
  margin: 0 0 40px;
}

.bp-meta a {
  display: inline-block;
  font-size: 16px;
  line-height: 16px;
  font-family: PingFang SC;
  color: #000000;
  font-weight: 500;
  margin-right: 30px;
}

.bp-meta a i {
  color: #F55C57;
  margin-right: 9px;
  position: relative;
  top: 1px;
}

.bp-meta a:last-child {
  margin-right: 0;
}

.bp-meta a:hover {
  color: #F55C57;
}

.b-post-details h3 {
  height: 19px;
  font-size: 19px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  line-height: 19px;
  margin-bottom: 22px;
}


.b-post-details h3 a:hover {
  color: #F55C57;
}

.post-item-1:hover {
  -webkit-box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
  -moz-box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
  box-shadow: 0px 30px 50px 0px rgba(11, 02, 55, 0.10);
}
.a-color{
  padding-left:25px ;
  position: relative;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #959595 !important;
line-height: 16px ;
background-image: url(/static/img/icon_shijainhasohi.png);
background-repeat: no-repeat;
background-size: 16px 16px;
background-position: left center;
}
.a-changebac{
  margin-left: 65px;
  background-image: url('/static/img/user-6-line (1)hong.png');
}
/* fenyeqi s */
.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #4462CF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li:not(.active):hover {
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .el-pager li {
  width: 25px;
  min-width: 25px;
  height: 25px;
  background: #EEEEEF;
  border-radius: 50%;
  line-height: 25px;
}

.pagination-wrap>>>.el-pagination.is-background .btn-prev {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;
}

.pagination-wrap>>>.el-pagination.is-background .btn-next {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border: 1px solid #4462CF;
  border-radius: 50%;
  background: #fff;
  color: #4462CF;

}

.pagination-wrap>>>.el-pagination .btn-prev .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination .btn-next .el-icon {
  font-size: 16px;
}

.pagination-wrap>>>.el-pagination {
  width: 1200px;
  text-align: right;
  height: 35px;
  padding-top: 4px;
  padding-bottom: 40px;
}

.pagination-wrap>>>.el-pager {
  height: 35px;
}

.pagination-wrap>>>.el-pager li {
  padding: 0;
  font-size: 14px;
  color: #666666;
}
</style>
